import type { ReactNode } from 'react'

// Bare URLs in trading-note text become clickable anchors. Matches
// http(s):// URLs plus www.-prefixed hosts (href gets https:// prepended).
const URL_RE = /https?:\/\/[^\s<>]+|www\.[^\s<>]+/g

// Turn the plain-text note content into text nodes + <a> elements. Trailing
// sentence punctuation is peeled off the match ("see https://x.com/page."
// links to the page, not the dot); a trailing ')' only stays when the URL
// itself contains a '(' (Wikipedia-style paths).
export function linkifyText(text: string): ReactNode[] {
  const out: ReactNode[] = []
  let last = 0
  for (const m of text.matchAll(URL_RE)) {
    let url = m[0].replace(/[.,;:!?'"”’]+$/, '')
    if (url.endsWith(')') && !url.includes('(')) url = url.slice(0, -1)
    const start = m.index
    if (start > last) out.push(text.slice(last, start))
    out.push(
      <a
        key={`${start}-${url}`}
        className="ad-note-link"
        href={url.startsWith('www.') ? `https://${url}` : url}
        target="_blank"
        rel="noopener noreferrer"
      >
        {url}
      </a>,
    )
    // Peeled punctuation flows into the next text slice.
    last = start + url.length
  }
  if (last < text.length) out.push(text.slice(last))
  return out
}
